import {
  Box,
  Button,
  Flex,
  HStack,
  Portal,
  Text,
  useDisclosure,
  VStack
} from "@chakra-ui/react";
import { useLocation, useNavigate } from "react-router-dom";
import TrDashboardHeader from "../../../components/common/TrainerDashboardHeader";
import TrainerSidenav from "../../../components/trainer/courses/Sidenav";
import { UpdateProgramResultModal } from "../../../components/trainer/courses/UpdateProgramResultModal";

const UpdateResult = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { resultDetails, programBool } = location.state;
  const updateCourseResultDisclosure = useDisclosure();
  const updateProgramResultDisclosure = useDisclosure();

  const handleResultUpdate = () => {
    if (programBool) {
      updateProgramResultDisclosure.onOpen();
          } else {
      updateCourseResultDisclosure.onOpen();
          }
  };

  // useEffect(() => {
  //     });

  return (
    <>
      <Box>
        <TrDashboardHeader />
      </Box>
      <Box bg="#F9F8F8" minHeight="100vh" height="auto" pl="40px" width="auto">
        <Flex width="90%" mx="auto" pt="80px" pb="150px">
          <TrainerSidenav />
          <Box
            width={{ lg: "80%", md: "80%", sm: "95%", base: "95%" }}
            mx="auto"
            mb="1rem"
            padding={{ lg: "2.5rem", md: "2rem", sm: "1.4rem", base: "1.4rem" }}
            bg="white"
          >
            <VStack
              justifyContent="space-between"
              alignItems="flex-start"
              py="26px"
              gap="1.8rem"
            >
              <Text color={"#1E1E1E"} fontSize={"24px"} fontWeight={"600"}>Title: {resultDetails.course_name}</Text>
              <HStack>
                <Text>Status: </Text>
                {resultDetails.is_published === 0 ? (
                  <Box
                    bg="#F79E1B"
                    padding={"4px 10px"}
                    borderRadius={"20px"}
                    width={"fit-content"}
                    
                  >
                    <Text color="white">Pending Review</Text>
                  </Box>
                ) : resultDetails.is_published === 1 ? (
                  <Box
                    bg="#47BD61"
                    padding={"4px 10px"}
                    borderRadius={"20px"}
                    width={"fit-content"}
                  >
                    <Text color="white">Accepted</Text>
                  </Box>
                ) : (
                  <Box
                    bg="#EC3337"
                    padding={"4px 10px"}
                    borderRadius={"20px"}
                    width={"fit-content"}
                  >
                    <Text color="white">Declined</Text>
                  </Box>
                )}
              </HStack>
              <Text>Exam Total Score: {resultDetails?.exam_total_score}</Text>
              <Text>Merit Score: {resultDetails?.merit_score}</Text>
              <Text>Pass Score: {resultDetails?.pass_score}</Text>
              <Text>Practical Total Score: {resultDetails?.practical_total_score}</Text>
              <Text>Task Total Score: {resultDetails?.tasks_total_score}</Text>
              <Text>Total Score: {resultDetails?.total_score}</Text>
              <HStack width={"100%"} justifyContent={"flex-end"}>
                <Button onClick={() => navigate(-1)}>Back</Button>
                {
                  resultDetails.is_published !== 1 &&
                    <Button onClick={() => handleResultUpdate()} colorScheme="red">Update Result Template</Button>
                }
              </HStack>
            </VStack>
          </Box>
        </Flex>

        <Portal>
          {" "}
          <UpdateProgramResultModal
            isOpen={updateProgramResultDisclosure.isOpen}
            onClosed={updateProgramResultDisclosure.onClose}
            session={resultDetails.course_session_id}
            term={resultDetails.course_term_id}
            ID={resultDetails.course_id}
            course_id={resultDetails.course_id}
            resultDetails={resultDetails}
          />{" "}
        </Portal>
        {/* <Portal>
          {" "}
          <UploadCourseResultModal
            isOpen={courseResultModalDisclosure.isOpen}
            onClosed={courseResultModalDisclosure.onClose}
            session={courseSession}
            term={courseTerm}
            ID={courseId}
            course_id={course_id}
          />{" "}
        </Portal> */}
      </Box>
    </>
  );
};

export default UpdateResult;
